import { defineMessages } from 'react-intl';

export const ratingTagMessaages = defineMessages({
  chipLabel: {
    id: 'rating.tag.chip.label',
    defaultMessage: '{name} {ratingCount} mal erwähnt',
  },
});
